import { Container, Grid, styled, Typography } from "@material-ui/core";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import useErmaStyling from "../../hooks/useErmaStyling";
import ErmaResponsiveGridItem from "./ErmaResponsiveGridItem";

const ErmaResponsiveRecordGrid = (props) => {
  const styling = useErmaStyling();

  const noRecords = !props?.records || props.records === null || props.records?.length === 0;

  /**
   * 
   * @returns 
   */
  const render = () => {
    return (
      <>
        { renderHeadingRow() }
        { noRecords && renderEmptyDataset() }
        { !noRecords && props.records.map(renderRecordRow) }
      </>
    );
  }


  /**
   * 
   */
  const renderEmptyDataset = () => {
    return (
      <Grid container xs={12} direction="row" justifyContent="center" className={styling.ermaStyles.gridTable_noRecords}>
        <InfoOutlinedIcon fontSize="large"/>
        <Typography>No records to display</Typography>
      </Grid>
    )
  }

  /**
   * Renders the Desktop Table Header
   * @returns 
   */
  const renderHeadingRow = () => {
    if ( styling.isMobile ) {
      return null;
    }

    return (
      <Grid container className={styling.ermaStyles.gridTable_rowHeading}>
        {
          props.children.map( (child, index) => {
            let classStyles = [styling.ermaStyles.gridTable_labelField];

            if (child.props.classes?.sm) {
              classStyles.push(child.props.classes.sm);
            }

            return (
              <Grid item xs={ child.props.xs } sm={ child.props.sm } key={index} className={ classStyles.join(" ") }>
                <Typography className={styling.ermaStyles.tableHeading}>{ child.props.label }</Typography>
              </Grid>
            )
          })
        }
      </Grid>
    );
  }

  /**
   * Renders a row for the supplied record object
   */
  const renderRecordRow = (record) => {
    let key = props.rowKey(record);

    return (
      <Grid container className={styling.ermaStyles.gridTable_row} key={key}>
        {
          props.children.map( (child, index) => { 
            return <ErmaResponsiveGridItem { ...child.props } record={record} key={(key + index)}/>
          })
        }
      </Grid>
    );
  }


  return render();
}

export default ErmaResponsiveRecordGrid; 